import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers.js";
import rumLabelsListener from "./middleware/rumLabelsListener";

const store = configureStore({
   reducer: rootReducer,
   middleware: (getDefaultMiddleware) =>
       getDefaultMiddleware().prepend(rumLabelsListener.middleware),
});
export default store